import { DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useAddEditIncidentAffectedServiceDialogHooks } from "./AddEditIncidentAffectedServiceDialog.hooks";
import { IncidentAffectedService } from "../incidentAffectedServices/IncidentAffectedServices.types";

export interface IAddEditIncidentAffectedServiceDialogProps {
    onDialogClose: () => void;
    incidentAffectedServiceToUpdate?: IncidentAffectedService;
    initialName?: string;
    onSaved: (incidentAffectedServiceId: string) => void;
}

function AddEditIncidentAffectedServiceDialog(props: IAddEditIncidentAffectedServiceDialogProps) {
    const { translateString } = useTranslation();
    const { isAdd, isSaving, onNameChange, onSave, saveModel, validation } = useAddEditIncidentAffectedServiceDialogHooks(props);

    return (
        <DotLegalDialog
            size="sm"
            inProgress={isSaving}
            header={isAdd ? translateString("createIncidentAffectedService") : translateString("editIncidentAffectedService")}
            buttonOkText={isAdd ? translateString("create") : translateString("save")}
            open
            onDialogClose={props.onDialogClose}
            onOkClick={onSave}
        >
            <DotLegalTextField
                label={translateString("name")}
                value={saveModel.name}
                debounce={false}
                errorText={validation.getErrorsForDisplay("name")}
                onChange={onNameChange}
            />
        </DotLegalDialog>
    );
}

export default AddEditIncidentAffectedServiceDialog;
